import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FilterSettingsModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { catchError, filter, switchMap, tap } from 'rxjs';
import { ConfirmService } from 'src/app/libs/confirm/confirm.service';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { PessoaDoencaService } from 'src/app/servicos/pessoa-doenca.service';

@Component({
  selector: 'app-paciente-doenca-lista',
  templateUrl: './paciente-doenca-lista.component.html',
  styleUrls: ['./paciente-doenca-lista.component.less']
})
export class PacienteDoencaListaComponent implements OnInit {

  @ViewChild('gridAtivas')
  gridAtivas!: GridComponent;

  @ViewChild('gridInativas')
  gridInativas!: GridComponent;
  
  toolbarDoencasAtivasItens: Object[] | null = null;
  toolbarDoencasInativasItens: Object[] | null = null;

  registrosDoencasAtivas: Object | null = null;
  registrosDoencasInativas: Object | null = null;

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }
  
  constructor(private pacienteService: PacienteService, 
    private pessoaDoenca: PessoaDoencaService,
    private toast: ToastService,
    private confirm: ConfirmService) { }

  ngOnInit(): void {

  }

  carregar() {
    this.pacienteService.listarDoencasAtivas().subscribe((doencas) => {
      this.registrosDoencasAtivas = doencas;
    });

    this.pacienteService.listarDoencasInativas().subscribe((doencas) => {
      this.registrosDoencasInativas = doencas;
    });
  }

}
